export default "__VITE_ASSET__398f15df__"